let products = [];

const notificationInit  = () => {
  const notificationContainer = document.createElement('div');
  notificationContainer.classList.add('notification-container');
  notificationContainer.innerHTML = `
    <div class="close-notification-btn">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
    </div>
    <a href="" id="NotificationLink" class="product-info">
      <img id="NotificationProductImage" />
      <div class="info">
        <div class="name">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/><circle cx="12" cy="12" r="3"/></svg>
          <span id="NotificationProductName"></span>
        </div>
        <div class="notification-footer">
          <div class="recently-purchased">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
            <span>Recently purchased</span>
          </div>
          <div class="time">2d ago</div>
        </div>
      </div>
    </a>
  `;

  document.body.appendChild(notificationContainer);

  const notifClose = document.querySelector('.close-notification-btn');
  const notifImage = document.querySelector('#NotificationProductImage');
  const notifName = document.querySelector('#NotificationProductName');
  const notifLink = document.querySelector('#NotificationLink');
  
  if (products.length > 0) {
    let currentIndex = 0;
    let isHovered = false;
    let isDismissed = false;
    let hideTimeout;
  
    const hideNotification = () => {
      notificationContainer.classList.remove('active');
      currentIndex = (currentIndex + 1) % products.length;
  
      setTimeout(showNotification, 20000);
    };
  
    const showNotification = () => {
      if (isDismissed) return;
  
      const product = products[currentIndex];
  
      notificationContainer.classList.add('active');
      notifImage.setAttribute('src', product.imageURL);
      notifName.innerText = product.name;
      notifLink.setAttribute('href', product.url);
  
      hideTimeout = setTimeout(() => {
        if (!isHovered) {
          hideNotification();
        }
      }, 4000);
    };
  
    notifClose.addEventListener('click', () => {
      isDismissed = true;
      notificationContainer.classList.remove('active');
  
      setTimeout(() => {
        isDismissed = false;
      }, 20000);
    });
  
    notificationContainer.addEventListener('mouseenter', () => {
      isHovered = true; 
      clearTimeout(hideTimeout); 
    });
  
    notificationContainer.addEventListener('mouseleave', () => {
      isHovered = false;
      hideTimeout = setTimeout(hideNotification, 4000);
    });
  
    showNotification();
  }
}

const fetchProduct = async (handle) => {
  try {
    const response = await fetch(`/products/${handle}.json`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${handle}`);
    }
    const productData = await response.json();
    
    products.push({
      name: productData.product.title,
      imageURL: productData.product.image?.src || '',
      url: `/products/${handle}`,
    });

    console.log(`Fetched product: ${productData.product.title}`);
  } catch (error) {
    console.error(error);
  }
};

(async () => {const productHandles = [];
    for (const handle of productHandles) {
      await fetchProduct(handle.trim());
    }console.log(products);
  notificationInit();
})();



